/* eslint-disable react/jsx-props-no-spreading */
import { Box, BoxProps } from '@mantine/core';
import { FC, ReactNode } from 'react';

interface Props extends BoxProps {
  children: ReactNode;
  rightSection?: ReactNode;
}

const GrayBox: FC<Props> = ({ children, rightSection, sx, ...rest }) => (
  <Box
    pos="relative"
    p="md"
    sx={(theme) => ({
      borderRadius: 10,
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
    })}
    {...rest}
  >
    {children}
    {rightSection && <Box sx={{ position: 'absolute', right: 10, top: 10 }}>{rightSection}</Box>}
  </Box>
);

export const GrayBoxV2: FC<Props> = ({ children, rightSection, sx, ...rest }) => (
  <Box
    pos="relative"
    p="md"
    sx={(theme) => ({
      borderRadius: 10,
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
    })}
    {...rest}
  >
    {children}
    {rightSection && <Box sx={{ position: 'absolute', right: 10, top: 10 }}>{rightSection}</Box>}
  </Box>
);

export default GrayBox;
